.side-navigation-mobile-nav-menu {
  background-color: #e8e8ed;
  margin: 2.4rem 0;
  padding: 1.6rem;
  border-radius: 0.4rem;
  cursor: pointer;

  &--closed {
    &:hover {
      background-color: #dcdce1;
    }
  }
}

.side-navigation-mobile-nav-menu__menu-items__item {
  margin: 0.4rem;
  padding: 0.4rem 1.6rem;

  &:hover {
    background-color: #dcdce1;
  }

  &--active {
    border-left: 2px solid #990ae3;
  }

  &--not-active {
    border-left: 2px solid transparent;
  }
}
